import React, {FunctionComponent} from 'react';
import './SelectOneModifierGroupEdit.less';
import {SelectList} from 'compositions/select-list/SelectList';
import {ModifierGroup, ModifierGroupId, ModifierGroupSelections} from '../../../helpers/modifier.helper.types';
import {SelectListItem} from '../select-list-item/SelectListItem';
import {Checkbox} from '../../elements/checkbox/Checkbox';
import {getModifierComputedName} from '../../../helpers/modifier.helper';

interface SelectOneModifierGroupEditProps {
	modifierGroup: ModifierGroup,
	modifierGroupSelections: ModifierGroupSelections,
	onModifierChange: (modifierGroupSelections: ModifierGroupSelections, changedModifierGroupId: ModifierGroupId) => void,
	onModifierDescriptionClick: (description: string, event: any) => void
}

const MinimumQuantity = 1;

export const SelectOneModifierGroupEdit: FunctionComponent<SelectOneModifierGroupEditProps> = (
	{
		modifierGroup,
		modifierGroupSelections,
		onModifierChange,
		onModifierDescriptionClick,
	}
) => {
	return (<SelectList>
		{
			modifierGroup.modifiers
				.sort((modifier1, modifier2) => modifier1.soldOut ? 1 : (modifier2.soldOut ? -1 : 0))
				.map(modifier => {
					const id = modifier.modifierId;
					const modifierSelection = modifierGroupSelections
						.find(modifierSelection => modifierSelection.modifierId === modifier.modifierId);
					const isSelected = !!modifierSelection;

					return (
						<SelectListItem
							checkboxControl={<Checkbox isChecked={isSelected} isRadio/>}
							key={id}
							name={getModifierComputedName(modifier)}
							description={modifier.description}
							onDescriptionClick={onModifierDescriptionClick}
							isSelected={isSelected}
							isDisabled={modifier.soldOut}
							onClick={() => {
								onModifierChange([{
									modifierId: id,
									quantity: modifier.defaultQuantity || MinimumQuantity
								}], modifierGroup.modifierGroupId);
							}}
						/>
					);
				})
		}
	</SelectList>);
};
